import { createTranslations } from '@momentum/i18n';
import { kciEnTranslations } from './kci.en';

export const kciHeTranslations = createTranslations(kciEnTranslations, {
  // Time Filter
  timePeriod: 'תקופת זמן',
  selectAnalysisTimeframe: 'בחר את מסגרת הזמן לניתוח',
  allTime: 'כל הזמנים',
  last12Months: '12 חודשים אחרונים',
  last3Months: '3 חודשים אחרונים',
  thisMonth: 'החודש הנוכחי',

  // Dashboard
  dashboard: 'KCI - מדדי תקשורת',
  overview: 'סקירת KCI',
  welcomeMessage: 'ברוכים הבאים ללוח הבקרה של KCI (ידע, יכולת, חדשנות).',
  focusEmployee: 'עובד במיקוד',
  selectEmployeeToAnalyze: 'בחר עובדים לניתוח מדדי ה-KCI שלהם',
  relatedEmployees: 'עובדים קשורים',
  selectEmployeesToCompare: 'בחר עובדים להשוואה',
  selectedTimePeriod: 'תקופת זמן נבחרת',
  selectedEmployees: 'עובדים נבחרים',
  noEmployeesSelected: 'לא נבחרו עובדים',
  employeeSelected: 'עובד(ים) נבחרו',
  selectedEmployeeList: 'עובדים נבחרים',

  // Score Cards
  performanceScore: 'KCI - מדדי תקשורת להצלחת הארגון',
  kciSubtitle: 'KCI - מדדי תקשורת להצלחת הארגון',
  loadingKciData: 'טוען נתוני KCI...',
  errorCalculatingScores: 'שגיאה בחישוב ציוני KCI',
  noCommunicationData: 'לא נמצאו נתוני תקשורת עבור התקופה שנבחרה.',
  solveScore: 'INTERA Score',
  pecTitle: 'תרומה אישית למאמץ',
  pecDescription: 'עד כמה קל לעבוד ולשתף פעולה איתי',
  ppcTitle: 'תרומה אישית לביצועים',
  ppcDescription: 'רמת התרומה שלי לעמידה ביעדים של עמיתיי',
  pesTitle: 'ציון מעורבות אישית (PES)',
  pesDescription: 'רמת המעורבות שלי בהצלחתו של הצוות שלי והארגון',
  pvaTitle: 'התאמה אישית לערכים',
  pvaDescription: 'עד כמה ערכי הארגון משתקפים בהתנהלות השוטפת שלי',

  // PES Suggestions
  pesSuggestions: 'הצעות PES',
  boostYourPes: 'שפר/י את ה-PES שלך',
  noPesSuggestions: 'אין הצעות PES לחודש הנוכחי',
  sendToYourEmployee: 'אינטראקציה עם העובד שלך',
  sendToTeammate: 'אינטראקציה עם עמית',
  suggestionType: 'סוג הצעה',
  suggestionManagerNotSentEmployee:
    'מנהל: שלח I Need You לעובדים שעדיין לא יצרת איתם אינטראקציה',
  suggestionEmployeeNotSentPeer:
    'עובד: שלח I Need You לעמיתים שעדיין לא יצרת איתם אינטראקציה',
  sendFeedbackSuggestion: 'שלח I Need You',
  sendFeedbackSuggestionDescription:
    'לא שלחת I Need You החודש. שלח I Need You כדי לשפר את ציון ה-PES שלך.',
  strongEngagementMessage: 'החודש הצגת מעורבות חזקה עם הצוות שלך.',
  connectWithColleagues: 'התחבר עם עמיתים שעדיין לא יצרת איתם קשר:',
  connectionsHelpStrengthenScore: 'קשרים אלה עוזרים לחזק את הציון שלך.',
  moreSuggestions: (count: number) => `+${count} עוד`,

  // Scoring Scale
  scoringScaleTitle: 'סולם ציוני KCI',
  scoreHighlySupportive: 'מקדם מאוד',
  scoreSupportive: 'מקדם',
  scoreNeutral: 'ניטרלי',
  scoreObstructive: 'מעכב',
  scoreHighlyObstructive: 'מעכב מאוד',

  // Overview Cards
  iSeeYou: 'I See You',
  iNeedYou: 'I Need You',
  iLearn: 'I Learn',
  sent: 'נשלחו',
  received: 'התקבלו',
  created: 'נוצרו',
  unresolved: 'לא פתורים',
  resolved: 'פתורים',
  participated: 'השתתפויות',

  // Trends
  trendsTitle: 'מגמות KCI',
  hidden: 'מוסתר',
  monthJan: 'ינו',
  monthFeb: 'פבר',
  monthMar: 'מרץ',
  monthApr: 'אפר',
  monthMay: 'מאי',
  monthJun: 'יונ',
  monthJul: 'יול',
  monthAug: 'אוג',
  monthSep: 'ספט',
  monthOct: 'אוק',
  monthNov: 'נוב',
  monthDec: 'דצמ',

  // Raw Data Table
  createdAt: 'נוצר ב',
  sender: 'שולח',
  receiver: 'מקבל',
  type: 'סוג',
  tags: 'תגיות',
  outcomeGoal: 'תוצאה/מטרה',
  loadingRawData: 'טוען נתונים גולמיים...',
  errorLoadingRawData: 'שגיאה בטעינת נתונים גולמיים',
  noData: 'אין נתונים',
  noGoal: 'לא צוינה מטרה',
  completed: 'הושלם',
  pending: 'ממתין',
  self: 'עצמי',
  filtered: 'מסונן',
  allCommunicationsTitle: 'כל האינטראקציות של {{userName}}',
  filteredCommunicationsTitle: 'תקשרויות - {{userName}} ({{count}} מסוננות)',

  // Radar
  radarValue: 'ערך',
  radarDescription: 'תיאור',
  radarAlignmentScore: 'ציון התאמה',
  radarScore: 'ציון',
  radar: {
    // Loading and Error States
    loadingRadarData: 'טוען נתוני רדאר...',
    errorLoadingRadarData: 'שגיאה בטעינת נתוני רדאר',
    retry: 'נסה שוב',

    // Score Selector Options
    workOption: 'עד כמה קל לעבוד איתי?',
    promoteOption: 'עד כמה אני מקדם את יעדי העמיתים שלי?',
    alignmentOption: 'ההתאמה שלי לערכים',

    // Time Range Select
    timeRange: 'טווח זמן',

    // Employee Select
    selectEmployee: 'בחר עובד...',
    loadingEmployees: 'טוען עובדים...',
    errorLoadingEmployees: 'שגיאה בטעינת עובדים',
    noEmployeesAvailable: 'אין עובדים זמינים',
    focusedEmployee: 'עובד ממוקד',

    // Related Employees Select
    selectEmployees: 'בחר עובדים',
    selected: 'נבחר',
    relatedEmployees: 'עובדים קשורים',
    loadingRelatedEmployees: 'טוען עובדים קשורים...',
    errorLoadingRelatedEmployees: 'שגיאה בטעינת עובדים קשורים',
    noRelatedEmployeesFound: 'לא נמצאו עובדים קשורים',

    // Multi Select Header
    selectOptions: 'בחר/י אפשרויות',
    allSelected: 'הכל נבחר',
    selectAll: 'בחר הכל',
    clearAll: 'נקה הכל',

    // Grade Display
    personalEffortContribution: 'תרומת מאמץ אישי',
    personalPerformanceContribution: 'תרומת ביצועים אישית',
    personalValueAlignment: 'התאמה אישית לערכים',
    personalEngagementScore: 'ציון מעורבות אישית',
  },
});
